import { ColliEnumClient } from '@frontend/colli/api';
import { ColliTrigger, ColliTriggerName } from '@frontend/colli/types';
import { useAppSelector } from '@frontend/common';
import { SelectOption } from '@frontend/components/basic-forms';
import { fetchGeneralWorkflowTriggers, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { ColliTriggerSelectProps } from '././colli-trigger-select.component';

interface ViewProps {
    options: SelectOption<ColliTriggerName>[];
}

const useColliTriggerSelect = (props: ColliTriggerSelectProps): ViewProps => {
    const [triggers, changeTriggers] = useState<string[]>([]);
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowTriggers());
        ColliEnumClient.fetchColliTriggers().then(changeTriggers);
    }, []);

    const options = useMemo(() => {
        if (!triggers || !workflowSharedState.generalWorkflowTriggers) return [];
        return [...triggers, ...workflowSharedState.generalWorkflowTriggers].map((trigger) => {
            const found = ColliTrigger.ALL.find((t) => t.value === trigger);
            if (found) return { value: found.value, label: found.value, display: found.displayName };
            else
                return {
                    value: trigger,
                    label: trigger.replace(/_/g, ' ')
                };
        });
    }, [triggers, workflowSharedState.generalWorkflowTriggers]);

    return { options };
};

export default useColliTriggerSelect;
